import { ItemTaxViewData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { IElectronicJournalRecord } from '../interfaces/states/IElectronicJournalRecord';

export const getItemExemptedTax = (item: IElectronicJournalRecord): number => {
  const taxExemptions: Partial<ItemTaxViewData>[] =
    item.Taxes?.filter(exemption => exemption.exemptAmount ?? 0.0 > 0) ?? [];
  return taxExemptions.reduce((total, exemption) => total + (exemption.exemptAmount ?? 0.0), 0);
};
